/*
  FROM TB-539
  Michael Qin
  4 days ago (feb 19, 2018)
  修改补充：新的流程快设计完了，逻辑改变挺大的，暂时的解决方案如下：
  在班级列表的操作里添加“删除”按钮
  点击删除弹出提示框，提示两点信息，1，如果有未完成的课节要提示，2，告知删除后的班级去了已删除tab下，按钮为，取消与确定。
  删除完的班级或私课不会删除学校里的学生。
*/
import React, {Proptype, Component} from 'react'
import archiveClass from 'controllers/class/archiveClass';
import ClassDetail from 'mediators/ClassDetail';
import { confirm } from 'util/confirm';
import locale from './locale'

const FEE_TYPES = ['per_day', 'per_time', 'per_hour']

const Warning = (warning)=><div style={{color:'red'}}><p><i className='fa icon-attention-circled'/>{warning}</p></div>

export default function closeAndArchiveClass(classInfo, classType) {

  const classDetail = new ClassDetail(classInfo);

  const {
    id,
    feeType,
    totalQuantity,
    totalHours,
    usedLessonHours,
    usedLessonTimes,
    name,
  } = classDetail;

  let lessonLeft = 0;
  let message = '';

  switch(FEE_TYPES[feeType]) {
    case 'per_day':
      lessonLeft = totalQuantity - usedLessonTimes;
      break;
    case 'per_time':
      lessonLeft = totalQuantity - usedLessonTimes;
      break;
    case 'per_hour':
      lessonLeft = totalQuantity - usedLessonHours;
      break;
    default:
      break;
  }

  if (lessonLeft > 0) {
    message = Warning(__(' This class still has at least one unfinished lesson', 'closeClass'));
  }

  let title = '';
  let content = '';
  let content2 = '';

  if(classType == 'group'){
    title = __('Close Class', locale)
    content = __("After closing the class, you can find it under the 'Closed Class", locale)
    content2 = __('Are you sure you want to close the class below?', locale)
  } else {
    title = __('Close Private Class', locale)
    content = __("After closing the class, you can find it under the 'Closed Private Class", locale)
    content2 = __('Are you sure you want to close the private class below?', locale)
  }


  return new Promise((resolve, reject) => {
    confirm(
      <div>
        {message}
        <p>{content}</p>
        <p>{content2}</p>
        <div><b>{name}</b>
      </div>
      </div>, title)
    .then(()=>{
      archiveClass(id, classType)
      .then(({ data })=>{
        resolve(data);
      })
      .catch((err)=>{
        console.error(err);
        reject(err);
      });
    })
    .catch(()=>{
    });

  });

}



// WEBPACK FOOTER //
// ./src/process/class/closeAndArchiveClass.js